import { AxiosResponse } from 'axios';
import { KeyValue } from '@/main/models/common';
import { Result } from '@/main/models/common/resultResponse';
import { CultureFilterRequest } from '@/main/models/request/cultureRequest';

export abstract class ICultureApi {
  abstract getDomain(guidCountry: CultureFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>>;
}